import React from "react";
import Reveal from "./Reveal";

const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-[#091A33] py-24 md:py-32 overflow-hidden"
    >
      {/* Decorative gold corner accents */}
      <div className="absolute top-8 left-8 w-16 h-16 border-t border-l border-[#B89968]/40" />
      <div className="absolute bottom-8 right-8 w-16 h-16 border-b border-r border-[#B89968]/40" />

      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
              Don't Wait — Time Matters
            </span>
            <div className="h-px w-12 bg-[#B89968]" />
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            Let's protect what
            <br />
            <span className="italic gold-text">you've built.</span>
          </h2>
          <p className="mt-8 text-lg md:text-xl text-[#CBD5E1] max-w-2xl mx-auto leading-relaxed">
            One conversation can change the direction of your case. Reach out
            today — we'll listen, and we'll fight for you.
          </p>
          <button
            onClick={scrollToForm}
            data-testid="final-cta-button"
            className="mt-10 inline-flex items-center gap-3 bg-[#B89968] hover:bg-[#CFB079] text-[#0F2240] px-10 py-5 font-bold uppercase tracking-[0.2em] text-sm md:text-base transition-colors duration-300 group"
          >
            Start Your Free Consultation
            <span className="inline-block transition-transform group-hover:translate-x-1">
              →
            </span>
          </button>
          <p className="mt-6 text-sm text-[#94A3B8]">
            No fee unless we win • 100% confidential • Available 24/7
          </p>
        </Reveal>
      </div>
    </section>
  );
}
